import { useMutation, useQuery } from '@tanstack/react-query';
import { ExtraQueryParams } from 'helpers/utils/reactQuery';
import { getMergedParamsFromObject } from 'helpers/utils/RequestUtils';
import { getAssembleiasAssessorBffEndpoint } from 'library/Apis';
import { Mutations, Queries } from 'library/queries';
import ApiService from './ApiService';

export type ChatAssessor = {
  nome: string;
  cpfUsuario: string;
  flgDestaque: boolean;
  duvidas: {
    idDuvidaFrequente: number;
    duvida: string;
    dataDuvida: string;
    flgPublica: boolean;
    usuarioResposta: string;
    resposta: string;
    dataResposta: string;
    lido: boolean;
    flgEmResposta: boolean;
    ldapResposta: string;
    lidoAssessor: boolean;
  };
};

export type ChatAssessorPages = {
  totalElements: number;
  totalPages: number;
  countMensagensRespondidas: number;
  countMensagensPendentes: number;
  countMensagensEmResposta: number;
  elements: ChatAssessor[];
};

export interface MensagensFiltros extends Record<string, any> {
  nomeAssociadoOrCpf?: string;
  page?: number;
  respondido?: boolean;
  emResposta?: boolean;
  size?: number;
}

export const useGetAssessorDuvidas = (
  idEvento?: number,
  nomeAssociadoOrCpf?: string,
  page?: number,
  respondido?: boolean,
  emResposta?: boolean,
  size?: number,
  extra?: ExtraQueryParams<ChatAssessorPages>
) => {
  const url = `${getAssembleiasAssessorBffEndpoint()}duvida/duvida-evento?${getMergedParamsFromObject(
    { idEvento, nomeAssociadoOrCpf, page, respondido, emResposta, size }
  )}`;

  const queryFn = async () => {
    const req = await ApiService.get<ChatAssessorPages>(url, {
      idEvento,
      nomeAssociadoOrCpf,
      page,
      respondido,
      emResposta,
      size,
    } as any);
    return req.data;
  };

  return useQuery<ChatAssessorPages>({
    queryKey: [Queries.GetDuvidasAssessor],
    staleTime: 1000 * 60 * 10, // 10 minutos
    retry: 2,
    retryDelay: 1000 * 2, // 2 segundos
    ...(extra ?? {}),
    queryFn,
  });
};

export const useMarcarLida = () => {
  const mutationFn = async (data: { idEvento: string; cpf: string }) => {
    const url = `${getAssembleiasAssessorBffEndpoint()}duvida/${String(
      data.idEvento
    )}/lido/${data.cpf}`;

    return await ApiService.put(url);
  };

  return useMutation({
    mutationKey: [Mutations.PutMarcarLido],
    mutationFn,
    throwOnError: false,
    retry: 1,
    retryDelay: 1000 * 2, // 2 seconds
    gcTime: Infinity,
  });
};
